import React, { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Box, Button } from '@node-space/ui-components'
import { PageHeader } from 'components/header/PageHeader'
import { PathNames } from 'constants/General'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { AddCustomerAgreementCta } from '../AddCustomer/AddCustomerAgreementCta'
import { LiveCustomersList } from './LiveCustomersList'

export const LiveCustomers = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const refetchRef = useRef<() => void>(() => {})

  const { enableCustomerFeeSetup } = useFeatureFlags()

  const FeeSetupButton = enableCustomerFeeSetup ? (
    <Button variant="secondary" onClick={() => navigate(PathNames.LIVE_CUSTOMER_FEE_SETUP)}>
      {t('customers.feeSetup.title')}
    </Button>
  ) : null

  const MassCustomerLimitsButton = (
    <Button variant="secondary" onClick={() => navigate(PathNames.MASS_CUSTOMER_LIMITS)}>
      {t('customers.massCustomerLimits')}
    </Button>
  )

  const AddButton = <AddCustomerAgreementCta refetchCustomers={() => refetchRef.current()} />

  return (
    <Box paddingB={8}>
      <PageHeader
        description={t('embeddedCustomers.description')}
        renderRightSection={
          <Box flex gapX={12}>
            {FeeSetupButton}
            {MassCustomerLimitsButton}
            {AddButton}
          </Box>
        }
      />
      <LiveCustomersList onRefetch={refetch => (refetchRef.current = refetch)} />
    </Box>
  )
}
